<template>
  <div class="align-rel-container">
    <md-button class="md-fab md-dense play-cta-fab_flat align-rel h-left v-center" @click="scroll('right')"><md-icon>keyboard_arrow_left</md-icon></md-button>
    <md-button class="md-fab md-dense play-cta-fab_flat align-rel h-right v-center" @click="scroll('left')"><md-icon>keyboard_arrow_right</md-icon></md-button>
    <!-- <md-button class="md-icon-button my-class right"><md-icon>keyboard_arrow_right</md-icon></md-button> -->
    <div class="images-scroll-box" id="scrollbox">
      <span class="image-container" v-for="(image,id) in images" :key="id">
        <div class="image-holder" v-bind:style="{ 'background-image': 'url(' + image.url + ')' }" :id="id" v-bind:class="{ selected: id==selectedImageIndex}" @click="selectImage(id)">
        </div>
      </span>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      images:{
        type:Array,
        required: true
      },
      selectedImageIndex:{
        type: Number,
        required: false
      },
      selectImageFunction:{
        type: Function,
        required: false
      }
    },
    data: function () {
      return {
      }
    },
    created() {
      this.selectedImageIndex = 0
    },
    methods: {
      scroll(direction){
        var element = document.getElementById("scrollbox");
        if(direction ===  "left")element.scrollLeft += 500;
        if(direction ===  "right")element.scrollLeft -= 500;
      },
      selectImage(id){
          this.selectedImageIndex = id
          this.selectImageFunction(id)
      }
    }
  };
</script>
<style scoped>
  @import '../../assets/styles/global.css';



  .images-scroll-box::-webkit-scrollbar {
      display: none;
  }

  .images-scroll-box{
      scroll-behavior: smooth;
      overflow-x: scroll;
      overflow-y: hidden;
      white-space: nowrap;
      overflow: scroll;
      background: #000000d1;
      box-sizing: content-box;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
  }

  .image-container{
    display: inline-block;
    overflow: hidden;
  }

  .image-holder:hover {
    transform: scale(1.5);
  }

  .image-holder{
    height: 130px;
    width: 200px;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    opacity: 0.7;
    cursor: pointer;
    transition: transform .2s;
  }

  .image-holder.selected{
    opacity: 1;
  }


</style>



// WEBPACK FOOTER //
// src/components/listingComponents/imgQuickGallery.vue